/** Agrupa la clave TOTP en bloques de 4 para leerla o teclearla sin perderse. */
export function groupSecret(secret: string): string {
    return (secret.match(/.{1,4}/g) ?? []).join(' ');
}
